<div>
  <p class="authentication__right__card_title">
    {{ 'LOGIN.AUTH.MFA.TITLE' | translate }}
  </p>

  <div class="authentication__right__card__field" fxLayout="column" fxLayoutAlign="center stretch">
    <p class="authentication__right__card_description">
      {{ 'LOGIN.AUTH.MFA.DESCRIPTION' | translate }}
    </p>

    <verification-code
      class="mt-27"
      [verificationCodeForm]="verificationCodeForm"
      (next)="insertVerificationCode.next()"
    ></verification-code>

    <small class="authentication__right__card__field-error mt-8" *ngIf="verificationCodeForm.hasError('incorrect')">
      {{ 'LOGIN.AUTH.MFA.INCORRECT_CODE' | translate }}
    </small>

    <p class="authentication__right__card_description mt-22">
      <span
        >{{ 'LOGIN.AUTH.MFA.WARNING' | translate }}
        <b class="cursor-pointer" (click)="toRecoveryCodeStep.next()">
          {{ 'LOGIN.AUTH.MFA.RECOVERY_CODE_BUTTON' | translate }}
        </b>
      </span>
    </p>
  </div>

  <button
    class="authentication__right__card_next mt-22"
    mat-raised-button
    (click)="insertVerificationCode.next()"
    [disabled]="verificationCodeForm.invalid || isLoading"
  >
    {{ 'LOGIN.AUTH.NEXT' | translate }}
  </button>
</div>
